<div class="flex flex-col">
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Mesas</h1>
        <p class="text-sm text-gray-500">Gerencie as mesas do restaurante</p>
      </div>
      <button
        (click)="createTable()"
        class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded"
      >
        Nova Mesa
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="statusFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="tables"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Número</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ativo</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-table let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono font-semibold">{{ table.number }}</td>
            <td class="px-6 py-2">
              <p-tag
                [value]="getStatusLabel(table.status)"
                [severity]="getStatusSeverity(table.status)"
                [rounded]="false"
              ></p-tag>
            </td>
            <td class="px-6 py-2">
              <span
                class="px-2 py-1 rounded-full text-xs"
                [ngClass]="{
                  'bg-green-100 text-green-800': table.active !== false,
                  'bg-red-100 text-red-800': table.active === false
                }"
              >
                {{ table.active !== false ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td class="px-6 py-2">
              <div class="flex flex-wrap gap-2 items-center">
                <p-button
                  pTooltip="Alterar para Disponível"
                  icon="pi pi-check"
                  text
                  severity="success"
                  [disabled]="table.status === 'DISPONIVEL'"
                  (click)="changeStatus(table, 'DISPONIVEL')"
                ></p-button>
                <p-button
                  pTooltip="Alterar para Ocupada"
                  icon="pi pi-user"
                  text
                  severity="warn"
                  [disabled]="table.status === 'OCUPADA'"
                  (click)="changeStatus(table, 'OCUPADA')"
                ></p-button>
                <p-button
                  pTooltip="Alterar para Reservada"
                  icon="pi pi-calendar"
                  text
                  severity="info"
                  [disabled]="table.status === 'RESERVADA'"
                  (click)="changeStatus(table, 'RESERVADA')"
                ></p-button>
                <p-button
                  pTooltip="Editar"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(table)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-8 text-gray-500">Nenhuma mesa encontrada</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
